import Dependencies from "./Dependencies.js";
import DeviceTypeId from "./DeviceTypeId.js";
import DeviceType from "./DeviceType.js";
import Id from "./Id.js";
import IsArchived from "./IsArchived.js";
import Metadata from "./Metadata.js";
import ProjectId from "./ProjectId.js";
import SemanticVersion from "./SemanticVersion.js";
import Type from "./Type.js";
import Version from "./Version.js";
import Name from "./Name.js";
export default {
  Dependencies,
  DeviceTypeId,
  DeviceType,
  Id,
  IsArchived,
  Metadata,
  ProjectId,
  SemanticVersion,
  Type,
  Version,
  Name
};
export { Dependencies, DeviceTypeId, DeviceType, Id, IsArchived, Metadata, ProjectId, SemanticVersion, Type, Version, Name };